import { useEffect, useState } from "react";

/** Tailwind's `lg` breakpoint — the width at which our desktop layouts start. */
const DESKTOP_MIN_WIDTH_PX = 1024;

/**
 * Tells a component whether the browser is at desktop width right now, and
 * re-renders it when that changes (resize, phone rotated, window dragged).
 *
 * Use it only when JavaScript has to behave differently — plain layout
 * differences belong in `tw:lg:` classes, not here.
 */
const useIsDesktop = () => {
  const mediaQuery = `(min-width: ${DESKTOP_MIN_WIDTH_PX}px)`;
  const [isDesktop, setIsDesktop] = useState(
    () => window.matchMedia(mediaQuery).matches
  );

  useEffect(() => {
    const query = window.matchMedia(mediaQuery);
    const handleChange = (event) => setIsDesktop(event.matches);

    // Keep state in sync in case the width changed between render and effect.
    setIsDesktop(query.matches);
    query.addEventListener("change", handleChange);
    return () => query.removeEventListener("change", handleChange);
  }, [mediaQuery]);

  return isDesktop;
};

export default useIsDesktop;
